// @ts-nocheck
import { reducers } from "@insite/client-framework/Store/Reducers";
import accountSettingsReducer, {
    AccountSettingsActions,
} from "@store/Extensions/Store/Pages/AccountSettings/AccountSettingsReducer";
import checkoutReviewAndSubmitReducer, {
    CheckoutReviewAndSubmitActions,
} from "@store/Extensions/Store/Pages/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitReducer";
import getExtensionPropsFromCombinedReducer from "@toolkit/Framework/Common/Utilities/redux/getExtensionPropsFromCombinedReducer";
import { combineReducers } from "redux";

const pagesReducer = combineReducers({
    ...getExtensionPropsFromCombinedReducer(reducers.pages),
    accountSettings: accountSettingsReducer,
    checkoutReviewAndSubmit: checkoutReviewAndSubmitReducer,
});

export type PagesActions = AccountSettingsActions | CheckoutReviewAndSubmitActions;

export default pagesReducer;
